import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from './models/user';
import { Horse_show } from './models/horse_show';
import { Router } from '@angular/router';
import { SessionService } from './providers/session.service';
import { AuthService } from './providers/auth.service';
import { isAdoptedSession, adoptedSessionLabel } from './providers/auth-token';
import { VersionCheckService } from './providers/version-check.service';
import { AppSettings } from './app.settings';
import { faUserCircle, faBars }  from '@fortawesome/fontawesome-pro-regular';
import { faList, faPenSquare, faUserPlus, faHorseHead, faHorse, faUserHardHat, faUserShield, faEnvelopeOpenText, faHashtag, faEnvelopeOpen, faBallotCheck, faPlusOctagon, faMinusOctagon, faFileEdit, faQuestionCircle, faIdBadge, faFileInvoiceDollar } from '@fortawesome/pro-regular-svg-icons';
import { faShoppingCart } from '@fortawesome/fontawesome-pro-regular';

import { ModalReloadAppComponent } from './components/modal-reload-app/modal-reload-app.component';
import { Subscription }   from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'SHOW MANAGEMENT SYSTEM EQUESTRIAN EVENT PLATFORM';
  user: User = new User({username: "USER NOT SET"});
  faUserCircle = faUserCircle;
  faBars = faBars;
  collapse: boolean = true;
  browser_warn: boolean = false;
  faUserPlus = faUserPlus;
  faPenSquare = faPenSquare;
  faHorseHead = faHorseHead;
  faUserShield = faUserShield;
  faUserHardHat = faUserHardHat;
  faEnvelopeOpenText = faEnvelopeOpenText;
  faHashtag = faHashtag;
  faList = faList;
  faHorse = faHorse;
  faEnvelopeOpen = faEnvelopeOpen;
  faBallotCheck = faBallotCheck;
  faPlusOctagon = faPlusOctagon;
  faMinusOctagon = faMinusOctagon;
  faFileEdit = faFileEdit;
  faQuestionCircle = faQuestionCircle;
  faShoppingCart = faShoppingCart;
  faIdBadge = faIdBadge;
  faFileInvoiceDollar = faFileInvoiceDollar;

  is_canadian: boolean = false;
  app_version: string = '';

  // Set once at construction. The adopt screen does a full page load rather than
  // a router navigation precisely so this is re-read, and so no service is left
  // holding the previous user's cached state.
  is_adopted_session: boolean = isAdoptedSession();
  adopted_session_label: string = adoptedSessionLabel();

  //keep refs to subscriptions to be able to unsubscribe later
  private horseShowSubscription: Subscription;

  endAdoptedSession() {
    this.authService.logout().then(() => {
      window.location.href = '/login';
    }).catch(() => {
      // logout() only touches localStorage, but never strand an admin inside
      // someone else's session because a cache clear threw.
      window.location.href = '/login';
    });
  }

  constructor(private router: Router,
    private authService: AuthService,
    private sessionService: SessionService,
    private versionCheckService: VersionCheckService,
    private modal: NgbModal){
  	  this.sessionService.user$.subscribe(user => {
  		this.user = user;
  	});
    this.horseShowSubscription = this.sessionService.horse_show$.subscribe((horse_show: Horse_show) => {
      this.is_canadian = horse_show?.country_iso_3 === 'CAN';
    });
    this.versionCheckService.current_version$.subscribe(version => {
      this.app_version = version;
    });
  }

  ngOnInit(){

    this.browser_warn = /msie\s|trident\//i.test(window.navigator.userAgent);

    this.versionCheckService.initVersionCheck(AppSettings.APP_VERSION_CHECK_PATH);

    let reload_modal_open = false;
    this.versionCheckService.version_changed$.subscribe(version_has_changed => {
      if (version_has_changed && !reload_modal_open) {
        reload_modal_open = true;
        const modal_ref_reload = this.modal.open(ModalReloadAppComponent, { size: 'lg', backdrop: 'static' });
        modal_ref_reload.result.finally(() => { reload_modal_open = false; });
      }
    });

  }

  ngOnDestroy() {
    this.horseShowSubscription.unsubscribe();
  }

}
